import React, {useState, useEffect, Fragment, useContext} from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Button, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, IconButton }from '@mui/material';
import { alpha } from '@mui/material/styles';

import TuneRoundedIcon from '@mui/icons-material/TuneRounded';

import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';

import useTableStore from '../../../store/table';

// table context
import { useTableId } from '../../../contexts/TableId';

// icons
import FilterAltIcon from '@mui/icons-material/FilterAlt';

import FilterChip from './FilterFormComponents/FilterChip';

import FilterIcons from './FilterFormComponents/FilterIcons';

import { ActionButton } from '../../Common';

import NoItems from '../../NoItems';

import SelectForm from './FilterForms';

const ContentContainer = styled.div`
  display: flex;
  height: 50rem;
`;

const PaneHeaders = styled.h3`
  margin-bottom: 1.4rem;
`

const ViewPaneHeader = styled(PaneHeaders)`
  margin: 0;
`

const SelectionPane = styled.div`
  min-width: 35%;
  padding: 1.4rem;
`
const ViewPane = styled.div`
 flex-grow: 1;
 border-left: 1px solid ${props => props.theme.colors.border};
 background-color: ${props => props.theme.colors.lightBg};
 padding: 1.4rem;
 overflow-y: auto;
`;

const SelectionItems = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SelectionItem = styled.div`
  border: 1px solid ${props => props.theme.colors.borderDark};
  border-radius: 8px;
  padding: .5rem 1rem;
  margin-bottom: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;

  ${props => props.$selected ? css/* closed */`
    border-color: ${props.theme.colors.secondaryLighten};
    box-shadow: 0 0 2px 3px ${alpha(props.theme.colors.secondaryLighten, .2)};
  ` : ""}
`
const SelectionItemTopBar = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

const SelectionItemTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-weight: 500;
`

const SelectionItemArrow = styled.div`

`

const SelectionItemFilterList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: .8rem;
`;

const ViewPaneTopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ClearButton = styled(Button)`

`

const FilterComponent = ({ filters }) => {
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState({id: "", type: "", label: ""})

  const tableId = useTableId();

  const tableFilters = useTableStore(state => state.tableFilters[tableId]) || {};
  const resetFilters = useTableStore(state => state.resetTableFilters);
  const convertFilters = useTableStore(state => state.convertTableFilters);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    convertFilters(tableId);
    setOpen(false);
  };

  const handleClearAll = () => {
    resetFilters(tableId, null, null);
    handleClose();
  }

  const saveFunc = () => {
    // save function
    handleClose();
  }


  return (
    <Fragment>
      <Tooltip title="Advanced Filters">
        <ActionButton color="icon" variant="outlined" onClick={handleClickOpen}><FilterAltIcon /></ActionButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{padding: "1.4rem"}}>Filters</DialogTitle>
        <Divider />
        <ContentContainer>
          <SelectionPane>
            <PaneHeaders>Filters</PaneHeaders>
            <SelectionItems>
              {filters.map((f) => 
                <SelectionItem key={f.id} $selected={filter.id === f.id} onClick={() => setFilter({...f})}>

                  <SelectionItemTopBar>
                    <SelectionItemTitle>
                      <div><FilterIcons type={f.type} /></div>
                      <div>{f.label}</div>
                    </SelectionItemTitle>
                    <SelectionItemArrow>
                      <IconButton size="small">
                        <KeyboardArrowRightRoundedIcon />
                      </IconButton>
                    </SelectionItemArrow>
                  </SelectionItemTopBar>
                  <SelectionItemFilterList>
                    <FilterChip id={f.id} filter={tableFilters[f.id]} />
                  </SelectionItemFilterList>
                </SelectionItem>
              )}
            </SelectionItems>
          </SelectionPane>
          <ViewPane>            
           {filter.id ? (
            <>
              <ViewPaneTopBar>
                <ViewPaneHeader>{filter.label}</ViewPaneHeader>
                <ClearButton size='small' color="basic" onClick={() => resetFilters(tableId, filter.id, null)}>Clear Filter</ClearButton>
              </ViewPaneTopBar>
              <SelectForm tableId={tableId} {...filter} />
            </>
          ) : <NoItems title="Please select a filter from the left pane" />}
          </ViewPane>
        </ContentContainer>
        <Divider />
        <DialogActions>
          {/* <Button onClick={handleClose} color="secondary"variant='text'>Cancel</Button> */}
          <Button onClick={handleClearAll} color="secondary"variant='outlined'>Clear All</Button>
          <Button onClick={saveFunc} color="secondary" variant="contained" startIcon={<TuneRoundedIcon />}>Apply Filters</Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}

export default FilterComponent;